import React from 'react';
import { connect } from 'react-redux';
import HeaderLinksContainer from './header-links-container';

const HeaderLinksRedux = (props) => (
  <HeaderLinksContainer {...props} />
);

const mapStateToProps = (state, ownProps) => {
  const { entityId, entityType } = ownProps;

  // Dynamic mapping according to the entity type
  let currentEntity;
  switch (entityType) {
    case 'guide':
      const { guides } = state;
      currentEntity = guides?.guide?.editor[entityId];
      break;
    case 'company-category':
      const { companyCategories } = state;
      currentEntity = companyCategories?.editor[entityId];
      break;
    case 'landing-page':
      const { landingPages } = state;
      currentEntity = landingPages?.landingPage?.editor[entityId];
      break;
    default:
      currentEntity = {};
  }

  return {
    currentEntity,
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { entityId, entityType } = ownProps;

  // Dynamic import of actions according to the entity type
  let setHeaderLinksAction;
  switch (entityType) {
    case 'guide':
      setHeaderLinksAction = require('../../../../state/actions/guide-editor').setHeaderLinks;
      break;
    case 'company-category':
      setHeaderLinksAction = require('../../../../state/actions/company-category-editor').setHeaderLinks;
      break;
    case 'landing-page':
      setHeaderLinksAction = require('../../../../state/actions/landing-page-editor').setHeaderLinks;
      break;
    default:
      setHeaderLinksAction = () => ({});
  }

  return {
    onHeaderLinksChange: (headerLinks) => dispatch(setHeaderLinksAction(entityId, headerLinks)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLinksRedux);
